module.exports = __webpack_public_path__ + "img/swager.fc4e6196.png";